module.exports = __webpack_public_path__ + "img/Recurso-4.1921fe21.png";